import * as React from 'react';
import { ReactElement, useCallback } from 'react';
import { useModelDefinition, useModelValue } from './hooks';
import { ParameterType, ShapeDiverValue } from '../../shape-diver';
import { useDispatch, useSelector } from 'react-redux';
import { changeValue } from '../../features/values/values-slice';
import inputFactory from './input-factory';
import { unsafeCast } from '../../utils';
import { InputConfig } from '../../config';
import StubInput from './stub-input';
import { RootState } from '../../store';
import { Parameter } from 'shapediver-types';

type ParameterDefinition = Parameter.ParameterDefinition;

function showLabel(d: ParameterDefinition | undefined): boolean {
  return d === undefined || d.type !== ParameterType.FILE;
}

type Props = {
  config: InputConfig;
};

export default function ModelInput(props: Props): ReactElement | null {
  const { config } = props;

  let modelName;
  let label;
  if (typeof config === 'string') {
    modelName = label = config;
  } else {
    modelName = config.name;
    label = config.label;
  }

  const definition = useModelDefinition(modelName);
  const value = useModelValue(modelName);
  const loadedFile = useSelector((state: RootState) => state.potterwareFile);

  const dispatch = useDispatch();

  const onInputChange = useCallback(
    (newValue: ShapeDiverValue) => {
      if (!definition || !definition.id) return;
      dispatch(changeValue({ id: definition.id, value: newValue }));
    },
    [dispatch, definition]
  );

  const inputComponent = definition ? (
    inputFactory(unsafeCast(value), label, definition, onInputChange)
  ) : (
    <StubInput name={modelName} />
  );

  const id = definition ? definition.id : modelName;

  return (
    <div className="pw-input" key={id}>
      {showLabel(definition) && (
        <label className="pw-input__label" htmlFor={id}>
          {label}:
        </label>
      )}
      <div className="pw-input__input" key={loadedFile}>
        {inputComponent}
      </div>
    </div>
  );
}
